module.exports = __webpack_public_path__ + "static/img/huanjingjiance.174632c0.jpg";